// npm packages
import React, { useState } from "react";
import {
  Button,
  CssBaseline,
  TextField,
  Typography,
  Container,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import store from "store2";

// components
import Footer from "../components/Footer";
import OfflineComponent from "../components/OfflineComponent";

// helpers
import validateEmail from "../helpers/validateEmail";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(10),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#A3080C",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#bd0d12",
      borderColor: "#564345",
    },
  },
}));

export default function Login(props) {
  const classes = useStyles();

  // if user is logged in, redirect to dashboard
  if (store.session.get("token")) {
    props.history.push("/");
  }

  // initial value of form objects
  const formObjects = { email: "", password: "" };

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState(formObjects);

  // validate login form
  const validateForm = () => {
    if (email.trim() === "") {
      setErrors({ email: "This field is required." });
      return false;
    } else if (!validateEmail(email)) {
      setErrors({ email: "Invalid Email." });
      return false;
    }

    return true;
  };

  const formHandler = async (e) => {
    e.preventDefault();

    // validate user inputs
    if (validateForm()) {
      try {
        // attempt user login
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/login`,
          { email, password }
        );

        const { token, user } = response.data?.data;

        if (
          user &&
          token &&
          (["admin", "stores"].includes(user.role.name) ||
            user.role.name.startsWith("delivery_admin"))
        ) {
          // if login is successful
          store.session("token", response.data.data.token);
          store.session("user", response.data.data.user);

          props.history.push("/");
        } else {
          setErrors({ email: "Access denied!" });
        }
      } catch (err) {
        // if login is not successful
        setErrors({ password: err.response.data?.message });
      }
    }
  };

  return (
    <>
      <OfflineComponent />
      <Container component="main" maxWidth="xs" className={classes.container}>
        <CssBaseline />
        <div className={classes.paper}>
          <Typography component="h1" variant="h5">
            KFC Delivery Tracker
          </Typography>
          <form className={classes.form} onSubmit={formHandler}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              type="email"
              label="Email"
              error={!!errors.email}
              helperText={errors.email}
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="Password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={!!errors.password}
              helperText={errors.password}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              className={classes.submit}
            >
              Log In
            </Button>
          </form>
        </div>
        <Footer />
      </Container>
    </>
  );
}
